module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/_function-to-string.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/_function-to-string.js
// module chunks = 0